import { useSelector, useDispatch } from "react-redux";
import { handleFooterType } from "@/store/layout";
import type { RootState, FooterType } from "@/types";

const useFooterType = (): [FooterType, (val: FooterType) => void] => {
  const dispatch = useDispatch();
  const footerType = useSelector((state: RootState) => state.layout.footerType);
  const setFooterType = (val: FooterType) => dispatch(handleFooterType(val));
  return [footerType, setFooterType];
};

export default useFooterType;
